export default __webpack_public_path__ + "31b994ddfa8c8c4bff81ed2728c5091d.png";